<template>
    <div class="wrapper tab-next-steps">
        <header>
            <span class="new-headline-md text-centered">Es geht los!</span>
        </header>

        <ol class="next-steps no-list-style">
            <li v-for="(item, index) in steps" :key="index">
                <span class="new-text-md text-green next-step-label">{{ item.label }}</span>
                <strong class="new-text-xl">{{ item.title }}</strong>
                <span class="new-text-lg">{{ item.text }}</span>
            </li>
        </ol>

        <div class="btn-group">
            <v-button label="Weiter" @onClick="$emit('answer')"></v-button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                steps: [
                    {
                        label: 'Jetzt',
                        title: 'Ihr Starter-Paket kommt per E-Mail',
                        text: 'Damit Sie noch heute loslegen können.'
                    },
                    {
                        label: 'Als Nächstes',
                        title: 'Wir kümmern uns um\u00A0Ihre Anfrage',
                        text: 'Sie hören bald von unserem\u00A0Team.'
                    },
                    {
                        label: 'Schon bald',
                        title: 'Ihr Vitadio-Programm beginnt',
                        text: 'Persönlich begleitet. Vollständig kostenfrei.'
                    }
                ]
            }
        }
    }
</script>
